import clsx from 'clsx';

import { ListItem } from './ListItem';

import type { ComponentProps, ElementType, JSX } from 'react';

import s from './List.module.css';

type AllowedComponentsPropsMap = Pick<JSX.IntrinsicElements, 'ul'>;

type AllowedComponentsTag = keyof AllowedComponentsPropsMap;

export type ListProps<T extends AllowedComponentsTag = 'ul'> = AllowedComponentsPropsMap[T] & {
  component?: T;
};

export const List = <T extends AllowedComponentsTag = 'ul'>({
  children,
  className,
  component,
  ...props
}: ListProps<T>) => {
  const Component = (component ?? 'ul') as ElementType;

  return (
    <Component className={clsx(s.list, className)} {...(props as ComponentProps<T>)}>
      {children}
    </Component>
  );
};

List.Item = ListItem;
